<template>
	<div>
		<PageHeaderLayout>
			<div class="main-page-content">
				<el-row class="table-search">
					<el-form :inline="true" :model="searchCondition" class="demo-form-inline">
						<el-form-item v-for="item in searchList" :key="item.props" :label="item.label">
							<el-input
								v-if="item.type === 'input'"
								v-model="searchCondition[item.props]"
								:placeholder="'请输入' + item.label"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="searchButton">查询</el-button>
							<el-button type="primary" @click="createAnnounce">创建公告</el-button>
						</el-form-item>
					</el-form>
				</el-row>

				<ApeTable
					ref="apeTable"
					:data="tableData"
					:columns="columns"
					:loading="loadingStaus"
					:pagingData="pagingData"
					@switchPaging="switchPaging"
					highlight-current-row
				>
					<el-table-column label="公告状态" width="100" align="center">
						<template slot-scope="scope">
							<el-switch
								:value="scope.row.status == 1"
								@change="changeStatus(scope.row)"
							></el-switch>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="180" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button type="text" size="mini" @click="editAnnounce(scope.row)">编辑</el-button>
							<el-button type="text" size="mini" @click="showDetail(scope.row)">详情</el-button>
							<el-popover placement="top" width="150" v-model="scope.row.deleteVisible">
								<p>确定要删除该公告吗？</p>
								<div style="text-align: right; margin: 0;">
									<el-button type="text" size="mini" @click="scope.row.deleteVisible = false">取消</el-button>
									<el-button type="danger" size="mini" @click="deleteAnnounce(scope.row)">确定</el-button>
								</div>
								<el-button slot="reference" type="text" size="mini" style="color: #f56c6c;">删除</el-button>
							</el-popover>
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>

		<el-dialog title="公告" :visible.sync="announceVisible" width="60%" @close="closeAnnounceDialog">
			<el-form ref="announceForm" :model="announceForm" :rules="rules" label-width="90px">
				<el-form-item label="公告标题" prop="title">
					<el-input v-model="announceForm.title" placeholder="请输入公告标题"></el-input>
				</el-form-item>
				<el-form-item label="公告内容" prop="content">
					<ApeEditor
						:init-html="announceForm.content"
						:editor-height="360"
						:oss-data="ossData"
						:oss-obj="ossObj"
						@handleTinymceInput="handleTinymceInput"
					/>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeAnnounceDialog">取 消</el-button>
				<el-button type="primary" :loading="submitLoading" @click="submitAnnounce">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="详情" :visible.sync="detailVisible" width="60%" @close="detailHtml = ''">
			<div class="detail-html" v-html="detailHtml"></div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="detailVisible = false">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeEditor from '@/components/ApeEditor/ApeEditor.vue'
import { search_list, tableColumns } from './config/announce.ts'

export default {
	name: 'HrManagerAnnounce',
	components: {
		PageHeaderLayout,
		ApeTable,
		ApeEditor
	},
	data() {
		return {
			searchCondition: {},
			searchList: search_list,
			columns: tableColumns.filter(item => item.value !== 'status_text'),
			loadingStaus: true,
			submitLoading: false,
			tableData: [],
			pagingData: {
				is_show: true,
				layout: 'total, sizes, prev, pager, next, jumper',
				total: 0
			},
			announceVisible: false,
			detailVisible: false,
			detailHtml: '',
			dialogFlag: 'add',
			actionId: '',
			announceForm: this.getDefaultForm(),
			rules: {
				title: [{ required: true, message: '请输入公告标题', trigger: 'blur' }],
				content: [{ required: true, message: '请输入公告内容', trigger: 'blur' }]
			},
			ossData: {},
			ossObj: {}
		}
	},
	methods: {
		getDefaultForm() {
			return {
				title: '',
				content: ''
			}
		},
		searchButton() {
			this.initList('search')
		},
		switchPaging() {
			this.initList()
		},
		formatList(list) {
			return list.map(item => {
				return {
					...item,
					content_text: this.stripHtml(item.content || ''),
					status_text: item.status == 1 ? '启用' : '停用',
					deleteVisible: false
				}
			})
		},
		stripHtml(value) {
			return String(value).replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ')
		},
		async initList(type) {
			this.loadingStaus = true
			const pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
			if (type === 'search') {
				pagingInfo.current_page = 1
			}
			try {
				const params = {
					...pagingInfo,
					...this.searchCondition
				}
				const res = await this.$api.getHrAnnounceList(params)
				const list = res.data || res.list || []
				const pages = res.pages || { total: res.total || 0, offset: res.offset || 0 }
				this.tableData = this.formatList(list)
				this.pagingData.total = pages.total || 0
				this.pagingData.offset = pages.offset || 0
			} catch (e) {
				this.tableData = []
				this.$message.error(e.message || '获取公告列表失败')
			}
			this.loadingStaus = false
		},
		createAnnounce() {
			this.dialogFlag = 'add'
			this.actionId = ''
			this.announceForm = this.getDefaultForm()
			this.announceVisible = true
		},
		async editAnnounce(row) {
			this.dialogFlag = 'edit'
			this.actionId = row.id
			try {
				const info = await this.$api.getHrAnnounceInfo(row.id)
				this.announceForm = {
					title: info.title || '',
					content: info.content || ''
				}
				this.announceVisible = true
			} catch (e) {
				this.$message.error(e.message || '获取公告详情失败')
			}
		},
		closeAnnounceDialog() {
			this.announceVisible = false
			this.submitLoading = false
			this.$refs.announceForm && this.$refs.announceForm.clearValidate()
		},
		handleTinymceInput(value) {
			this.announceForm.content = value
		},
		submitAnnounce() {
			this.$refs.announceForm.validate(async valid => {
				if (!valid) return
				this.submitLoading = true
				try {
					if (this.dialogFlag === 'add') {
						await this.$api.createHrAnnounce(this.announceForm)
					} else {
						await this.$api.editHrAnnounce(this.actionId, this.announceForm)
					}
					this.$message.success('保存成功')
					this.closeAnnounceDialog()
					this.initList()
				} catch (e) {
					this.$message.error(e.message || '保存失败')
				}
				this.submitLoading = false
			})
		},
		async showDetail(row) {
			try {
				const info = await this.$api.getHrAnnounceInfo(row.id)
				this.detailHtml = info.content || ''
				this.detailVisible = true
			} catch (e) {
				this.$message.error(e.message || '获取详情失败')
			}
		},
		async deleteAnnounce(row) {
			try {
				await this.$api.deleteHrAnnounce(row.id)
				this.$message.success('删除成功')
				row.deleteVisible = false
				this.initList('del')
			} catch (e) {
				this.$message.error(e.message || '删除失败')
			}
		},
		async changeStatus(row) {
			try {
				await this.$api.updateHrAnnounceStatus(row.id, {
					status: row.status == 0 ? 1 : 0
				})
				this.$message.success('操作成功')
				this.initList()
			} catch (e) {
				this.$message.error(e.message || '操作失败')
				this.initList()
			}
		},
		async getOssSign() {
			try {
				const ossDir = `${this.$config.ossAppDir || ''}/bill`
				const res = await this.$api.getOssSign({ dir: ossDir })
				if (res) {
					this.ossObj = { ...res, dir: res.dir || ossDir }
					this.ossData = {
						ossAccessKeyId: res.accessid,
						policy: res.policy,
						signature: res.signature
					}
				}
			} catch (e) {
				// 富文本图片上传失败时由编辑器处理
			}
		}
	},
	mounted() {
		this.getOssSign()
		this.initList()
	}
}
</script>

<style scoped lang="scss">
.table-search {
	margin-bottom: 16px;
}
.detail-html {
	max-height: 62vh;
	overflow: auto;
	font-size: 14px;
	line-height: 28px;
	color: #4e5969;
	/deep/ img {
		max-width: 100%;
		height: auto;
	}
}
</style>
